import { render, staticRenderFns } from "./ELOrderItem.vue?vue&type=template&id=5d091136&scoped=true"
import script from "./ELOrderItem.vue?vue&type=script&lang=js"
export * from "./ELOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d091136",
  null
  
)

export default component.exports